import React, { useState } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Button, ButtonToolbar, Spinner } from 'react-bootstrap'

import { loginRequest, logout } from '../../state/authActions'
import { getAuth } from '../../state/authReducer'
import styles from './Login.scss'

const mapStateToProps = (state, props) => {
  return getAuth(state)
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (username, password) => dispatch(loginRequest(username, password)),
    logout: () => dispatch(logout())
  }
}

const Login = (props) => {
  const { login, error, isAuthenticating, isAuthenticated } = props
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  return <div className={styles.background}>
    <div className={styles.center}>
      {isAuthenticated &&
        <Redirect to={{ pathname: '/' }} />
      }
      <h1 className={styles.heading}>COMTAX DOWNLOAD</h1>
      <div className={styles.users}/>
      <form name='form' className={styles.form}>
        <div className={'form-group' + (isAuthenticating && !username ? ' has-error' : '')}>
          <input type='text' placeholder='Username' className='form-control' name='username' value={username} onChange={(e) => setUsername(e.target.value)} />
          {isAuthenticating && !username &&
            <div className={styles.help}>Username is required</div>
          }
        </div>
        <div className={'form-group' + (isAuthenticating && !password ? ' has-error' : '')}>
          <input type='password' placeholder='Password' className='form-control' name='password' value={password} onChange={(e) => setPassword(e.target.value)} />
          {isAuthenticating && !password &&
            <div className={styles.help}>Password is required</div>
          }
        </div>
        <div className='form-group'>
          <ButtonToolbar>
            <Button className='btn-block' variant='primary' onClick={(e) => {
              e.preventDefault()
              login(username, password)
            }} disabled={isAuthenticating || !(username && password)}>
              {isAuthenticating ?
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                /> : 'Login'}
            </Button>
          </ButtonToolbar>
          {error &&
            <strong className={styles.error}>{error}</strong>
          }
        </div>
      </form>
    </div>
  </div>
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login))